<template>
  <div class="empty-list">
    <div class="empty-list-wrapper">
      <p>
        {{ $t('common.noResourceCreated', { item: pluralizedName }) }}
      </p>
      <router-link v-if="createRoute" :to="{ name: createRoute, params: params }" class="empty-list-wrapper-link">
        {{ $t('common.createNewResource', { item: resourceName }) }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { pluralize } from "../../helpers";

export default {
  name: "EmptyList",

  props: {
    resourceName: { type: String },
    createRoute: { type: String },
    params: { type: Object }
  },

  computed: {
    pluralizedName () {
      return pluralize(this.resourceName);
    }
  }
};
</script>
